import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  activateCauseOfDeath,
  createCauseOfDeath,
  deleteCauseOfDeath,
  fetchFarmCausesOfDeath,
  updateCauseOfDeath,
} from "redux/operations";
import type { RootState } from "redux/reducers";
import CauseOfDeathPage from "./causeOfDeathPage";

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

type CauseOfDeathContainerProps = StateProps & DispatchProps;

function CauseOfDeathContainer({
  activateCauseOfDeath,
  createCauseOfDeath,
  deleteCauseOfDeath,
  farmCausesOfDeath,
  fetchFarmCausesOfDeath,
  updateCauseOfDeath,
}: CauseOfDeathContainerProps) {
  useEffect(() => {
    fetchFarmCausesOfDeath();

    // We want to run this only once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleActivateCauseOfDeath = async (
    ...params: Parameters<typeof activateCauseOfDeath>
  ) => {
    await Promise.resolve(activateCauseOfDeath(...params));
    // Ensure cause of death is activated before refetching
    fetchFarmCausesOfDeath();
  };

  const handleCreateCauseOfDeath = async (
    ...params: Parameters<typeof createCauseOfDeath>
  ) => {
    await Promise.resolve(createCauseOfDeath(...params));
    // Ensure cause of death is created before refetching
    fetchFarmCausesOfDeath();
  };
  const handleUpdateCauseOfDeath = async (
    ...params: Parameters<typeof updateCauseOfDeath>
  ) => {
    await Promise.resolve(updateCauseOfDeath(...params));
    // Ensure cause of death is updated before refetching
    fetchFarmCausesOfDeath();
  };

  const handleDeleteCauseOfDeath = async (
    ...params: Parameters<typeof deleteCauseOfDeath>
  ) => {
    await Promise.resolve(deleteCauseOfDeath(...params));
    // Ensure cause of death is deleted before refetching
    fetchFarmCausesOfDeath();
  };

  return (
    <CauseOfDeathPage
      activateCauseOfDeath={handleActivateCauseOfDeath}
      farmCausesOfDeath={farmCausesOfDeath}
      createCauseOfDeath={handleCreateCauseOfDeath}
      deleteCauseOfDeath={handleDeleteCauseOfDeath}
      updateCauseOfDeath={handleUpdateCauseOfDeath}
    />
  );
}

const mapStateToProps = (state: RootState) => ({
  farmCausesOfDeath: state.causeOfDeath.farmCausesOfDeath,
});

const mapDispatchToProps = {
  activateCauseOfDeath,
  createCauseOfDeath,
  deleteCauseOfDeath,
  fetchFarmCausesOfDeath,
  updateCauseOfDeath,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(CauseOfDeathContainer);
